<template>
  <v-card
    :style="estilosTarjeta"
    class="d-flex align-center px-4 py-3"
    elevation="0"
  >
    <v-icon :color="colorTexto" class="mr-3">
      {{ iconoActual }}
    </v-icon>
    <span :style="{ color: colorTexto, fontWeight: '500', fontSize: '0.95rem' }">
      {{ message }}
    </span>
  </v-card>
</template>

<script>
export default {
  name: "IndicadorEstado",
  props: {
    message: {
      type: String,
      default: "SELECCIONE UNA MATERIA PARA VER Y AGREGAR TEMAS",
    },
    type: {
      type: String,
      default: "INFO", // Opciones sugeridas: INFO, WARNING, ERROR
    },
  },
  computed: {
    configuracionVisual() {
      // Tonos pastel muy suaves y textos apagados que no roban protagonismo
      const config = {
        INFO: {
          fondo: "#F0F4F8", // Un gris azulado muy tenue y limpio
          texto: "#546E7A", // Gris azulado medio (no es negro ni naranja chillón)
          icono: "mdi-information-outline",
        },
        WARNING: {
          fondo: "#FFF8E1", // Amarillo pastel sumamente suave
          texto: "#8D6E63", // Tono tierra/café apagado
          icono: "mdi-alert-circle-outline",
        },
        ERROR: {
          fondo: "#FFEBEE", // Rojo/rosa muy pálido
          texto: "#B71C1C", // Rojo apagado y oscuro
          icono: "mdi-close-circle-outline",
        }
      };

      return config[this.type.toUpperCase()] || config.INFO;
    },
    estilosTarjeta() {
      return {
        backgroundColor: this.configuracionVisual.fondo,
        borderRadius: "6px",
        // Sin bordes, solo el color sólido de fondo
      };
    },
    colorTexto() {
      return this.configuracionVisual.texto;
    },
    iconoActual() {
      return this.configuracionVisual.icono;
    },
  },
};
</script>